import { useLayoutEffect } from 'react';
import { useOutletContext } from 'react-router-dom';

import { LayoutContextType, LayoutProps } from '@components/layout/Layout';

const useLayoutProps = (props: LayoutProps) => {
  const { setLayoutProps } = useOutletContext<LayoutContextType>();

  useLayoutEffect(() => {
    setLayoutProps(props);
  }, [setLayoutProps, props]);
};

export default useLayoutProps;
